var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSelectBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 9.666,
    viewBox: "0 0 14.5 9.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow_Copy",
    d: "M7.683.3.235,6.758a.632.632,0,0,0,0,.984L7.683,14.2a1.292,1.292,0,0,0,1.644,0,.918.918,0,0,0,0-1.426L2.956,7.25,9.326,1.722A.919.919,0,0,0,9.326.3,1.292,1.292,0,0,0,7.683.3",
    transform: "translate(0 9.666) rotate(-90)",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSelectBlack);
export default __webpack_public_path__ + "static/media/arrow_select_black.fbfb86166dfe88e8cf9d75a8161bd133.svg";
export { ForwardRef as ReactComponent };